export const getSize = (size: number): { width: string; height: string } => ({
  width: `${size}px`,
  height: `${size}px`,
});
